export default {
  title: "Wallet Push-xabarnomalari",
  pushsBeAbleAfterEntityModeration:
    "Push-xabar yuborish imkoniyati sizning yuridik shaxsingiz moderatsiyadan o‘tgach faollashadi",
  toCreatePushBuyTariff:
    "Push-xabarlarni yuborish uchun «Promo» yoki «Pro+» tarifini sotib olish kerak",
  noPushsYet: "Push-xabarlar hali yo‘q",
  newPush: "Yangi xabarnoma",

  aboutChapter: {
    title: "Bo‘lim haqida",
    descriptions: [
      "«Wallet Push-xabarnomalari» bo‘limida siz mijozlaringizga yangiliklar, aksiyalar yoki tadbirlar haqida xabar yuborishingiz mumkin.",
      "Yuborilgan push-xabarlar jadval ko‘rinishida ko‘rsatiladi. Jadvaldagi qatorni bosib, xabar qaysi savdo nuqtasiga, qachon va qanday matn bilan yuborilganini ko‘rish mumkin.",
    ],
    howCreatePush: {
      header: "Mijozlarga push-xabarnoma yuborish tartibi",
      list: [
        "«Yangi xabarnoma» tugmasini bosing.",
        "Xabar yuboriladigan savdo nuqtasini tanlang.",
        "Sarlavhani kiriting, masalan: «Bayram chegirmalari».",
        "Xabar matnini yozing.",
        "Barcha ma’lumotlarni tekshiring – yuborilgandan keyin o‘zgartirib bo‘lmaydi!",
        "«Xabarnoma yaratish» tugmasini bosing.",
      ],
      p1: "Mijozlar xabarnomani yaratilganidan keyin 15 daqiqa ichida olishadi. Yaratilgan xabarnomani o‘zgartirish yoki bekor qilish mumkin emas.",
      p2: "<span>Muhiм!</span> Push-xabarnomalarni faqat sizning Wallet kartangizni telefoniga qo‘shgan mijozlar olishadi.",
    },
    hotGetWalletCard: {
      header: "Mijoz Wallet kartasini qanday chiqaradi",
      list: [
        "RC PAY mobil ilovasiga kiradi.",
        "Sizning muassasangizning Wallet kartasini chiqaradi.",
        "Uni Apple Wallet (iOS) yoki Google Pay (Android) ilovasiga qo‘shadi.",
      ],
    },
  },

  creatingPushNotAvailable: "Xabarnoma yaratish mumkin emas",
  clientsGetPushWithin: "Mijozlar push-xabarnomani 15 daqiqa ichida olishadi.",
  pushCreatedAndInProgress: "Xabarnoma yaratildi va qayta ishlanmoqda",

  pushCreating: "Xabarnoma yaratish",
  pushHeader: "Xabarnoma sarlavhasi",
  carefullyReadText: "Matnni diqqat bilan o‘qing",
  afterCreateUCantChangeIt:
    "Xabarnoma yaratilgandan keyin uni o‘zgartirish mumkin emas.",
  messageText: "Xabarnoma matni",
  createPush: "Xabarnoma yaratish",
  pushInfo: "Xabarnoma haqida ma’lumot",
};
